import moment from 'moment';
import * as R from 'ramda';
import React from 'react';
import { Paper, Grid, Button, Typography } from '@material-ui/core';
import SignaturePad from 'appModule/signature/containers/signaturePad';
import commonUtil from 'utilsModule/common';
import { connect } from 'react-redux';

const style = {
  trLeftColumn: {
    background: '#8080803b',
    width: '30%',
    fontWeight: '500',
  },
  lineInput: {
    borderStyle: 'groove',
    borderWidth: '0px 0px 2px 0px',
    fontSize: '16px',
    marginBottom: '15px',
  },
  signaturePadInput: {
    borderWidth: '0px 0px 2px 0px',
    marginLeft: '10px',
    borderStyle: 'groove',
    fontWeight: '400',
    fontSize: '16px',
  },
  sticky: {
    position: 'sticky',
    bottom: 0,
    background: 'inherit',
    zIndex: 9,
  },
  bold: {
    fontWeight: '500',
  },
};

@connect(state => ({
  currentOrganization: R.path(['resources', 'users', 'retrieveCurrent', 'organization'], state),
}), null)
class CRForm extends React.Component {
  KEY = 'pdf:changeRequestForm';

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      target_signature_ref: null,
      awaitPerformAction: false,
    };
  }

  getMomentLocale = () => {
    const { i18n } = this.props;
    const language =
      (i18n && (i18n.resolvedLanguage || i18n.language)) ||
      sessionStorage.getItem('language') ||
      'en';
    return commonUtil.getMomentLocaleMap(language);
  };

  formatCurrentDateDisplay = () => {
    const timezone = R.pathOr(moment.tz.guess(), ['currentOrganization', 'timezone'], this.props);
    return moment()
      .tz(timezone)
      .locale(this.getMomentLocale())
      .format('DD MMM YYYY');
  };

  formatStoredDateDisplay = (value) => {
    if (!value) return '';

    const locale = this.getMomentLocale();
    const parsed =
      [
        moment(value, 'DD-MMM-YYYY', 'en', true),
        moment(value, 'DD MMM YYYY', 'en', true),
        moment(value, 'DD-MMM-YYYY', locale, true),
        moment(value, 'DD MMM YYYY', locale, true),
        moment(value, 'YYYY-MM-DD', true),
        moment(value, moment.ISO_8601, true),
      ].find((candidate) => candidate.isValid()) || moment(value);

    return parsed.isValid() ? parsed.locale(locale).format('DD MMM YYYY') : value;
  };

  formatDateForStorage = () => {
    const timezone = R.pathOr(moment.tz.guess(), ['currentOrganization', 'timezone'], this.props);
    return moment()
      .tz(timezone)
      .format('DD-MMM-YYYY');
  };

  _handleClose = () => {
    this.setState({ open: false });
  }

  getActionLabel = (action) => {
    const actionMap = {
      RETURN: 'actions.return',
      REPLACE: 'actions.replace',
      ADD: 'actions.add',
      EXTEND: 'actions.extend',
      OTHERS: 'actions.others',
    };

    const actionKey = actionMap[action];
    if (!actionKey) return commonUtil.toTitleCase(action);

    return this.props.t(`${this.KEY}.${actionKey}`);
  };

  _signatureInput = (id, w) => {
    let _signatureRef = null;
    return (
      <div onClick={() => this.setState({ open: true, target_signature_ref: _signatureRef })} style={{ width: '250px', marginBottom: '15px' }}>
        <img id={id} style={{ maxWidth: '250px', maxHeight: '200px' }} ref={r => _signatureRef = r}
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAEaElEQVR4Xu3UgQkAMAwCwXb/oS10i4fLBHIG77YdR4AAgYDANViBlkQkQOALGCyPQIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiDwAIGUVl1ZhH69AAAAAElFTkSuQmCC" />
        <div style={R.merge(style.signaturePadInput, { width: w || 'auto' })} />
      </div>
    );
  }
  
  renderParticipantDetails = (crFormData, isReadOnly) => {
    const { participantDetails } = crFormData;
    return (
      <React.Fragment>
        <tr>
          <td style={style.trLeftColumn} rowSpan='2'>{this.props.t(`${this.KEY}.fields.participantDetails`)}</td>
          <td>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.participantName`)}</strong>&nbsp;&nbsp;
              {participantDetails.participantName}
            </p>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.participantIdType`)}</strong>&nbsp;&nbsp;
              {participantDetails.participantIDType}
            </p>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.participantIdNo`)}</strong>&nbsp;&nbsp;
              {participantDetails.participantIDNumber}
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.guardianName`)}</strong>&nbsp;&nbsp;
              {!isReadOnly ?
                <input ref={ref => this.guardianName = ref} style={R.merge(style.lineInput, { width: '80%', marginTop: '5px' })} type='text' /> :
                crFormData && crFormData.guardianName
              }
            </p>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.participantIdType`)}</strong>&nbsp;&nbsp;
              {!isReadOnly ?
                <input ref={ref => this.guardianIDType = ref} style={R.merge(style.lineInput, { width: '50%' })} type='text' /> :
                crFormData && crFormData.guardianIDType
              }
            </p>
            <p style={{ margin: '20px auto 20px auto' }}>
              <strong style={style.bold}>{this.props.t(`${this.KEY}.fields.participantIdNo`)}</strong>&nbsp;&nbsp;
              {!isReadOnly ?
                <input ref={ref => this.guardianIDNumber = ref} style={R.merge(style.lineInput, { width: '40%' })} type='text' /> :
                crFormData && crFormData.guardianIDNumber
              }
            </p>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  renderExtendDuration = () => (
    <tr>
      <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.descriptionOfChangeRequest`)}</td>
      <td>
        <div>
          <p>{this.props.t(`${this.KEY}.changeDescriptions.to`)} <strong style={style.bold}><u>{this.props.t(`${this.KEY}.changeDescriptions.extendVerb`)}</u></strong> {this.props.t(`${this.KEY}.changeDescriptions.subscriptionPeriod`)}</p>
          <span>{this.props.t(`${this.KEY}.changeDescriptions.extendedSubscriptionPeriodFor`)} <input style={R.merge(style.lineInput, { width: '7%', textAlign: 'center' })} readOnly type='text' /> {this.props.t(`${this.KEY}.fields.months`)} </span><br />
          <br />
          <span>
            {this.props.t(`${this.KEY}.fields.from`)}
            <input style={R.merge(style.lineInput, { width: '28%', textAlign: 'center' })} readOnly type='text' />
            {this.props.t(`${this.KEY}.fields.to`)}
            <input style={R.merge(style.lineInput, { width: '28%', textAlign: 'center' })} readOnly type='text' />
          </span>
          <br />
        </div>
        <br />
      </td>
    </tr>
  )

  renderAddDevice = () => (
    <tr>
      <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.descriptionOfChangeRequest`)}</td>
      <td>
        <div>
          <p>{this.props.t(`${this.KEY}.changeDescriptions.to`)} <strong style={style.bold}><u>{this.props.t(`${this.KEY}.changeDescriptions.addVerb`)}</u></strong> {this.props.t(`${this.KEY}.changeDescriptions.followingNewDevices`)}</p>
          <p>{this.props.t(`${this.KEY}.fields.deviceAccessory`)}</p>
          <p>{this.props.t(`${this.KEY}.fields.model`)} </p>
          <p>{this.props.t(`${this.KEY}.fields.serialNo`)}</p>
        </div>
      </td>
    </tr>
  )

  renderReplaceDevice = (crFormData) => {
    const { deviceInfo: { existingDevice, newDevice } } = crFormData;
    return (
      <tr>
        <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.descriptionOfChangeRequest`)}</td>
        <td>
          <div>
            <p style={{ margin: '20px auto 20px auto' }}>
              {this.props.t(`${this.KEY}.changeDescriptions.to`)} <strong style={style.bold}><u>{this.props.t(`${this.KEY}.changeDescriptions.replaceVerb`)}</u></strong> {this.props.t(`${this.KEY}.changeDescriptions.followingExistingDevices`)}
            </p>
            <p><u><strong style={style.bold}>{this.props.t(`${this.KEY}.changeDescriptions.existingCurrentDevice`)}</strong></u></p>
            <p>
              {this.props.t(`${this.KEY}.fields.deviceAccessory`)}&nbsp;&nbsp;
              {existingDevice && existingDevice.deviceName}
            </p>
            <p>
              {this.props.t(`${this.KEY}.fields.model`)}&nbsp;&nbsp;
              {existingDevice && existingDevice.deviceModel}
            </p>
            <p>
              {this.props.t(`${this.KEY}.fields.serialNo`)}&nbsp;&nbsp;
              {existingDevice && existingDevice.serialNo}
            </p>

            <p>
              <u>
                <strong style={style.bold}>{this.props.t(`${this.KEY}.changeDescriptions.newDevice`)}</strong>
              </u>
            </p>
            <p>
              {this.props.t(`${this.KEY}.fields.deviceAccessory`)}&nbsp;&nbsp;
              {newDevice && newDevice.deviceName}
            </p>
            <p>
              {this.props.t(`${this.KEY}.fields.model`)}&nbsp;&nbsp;
              {newDevice && newDevice.deviceModel}
            </p>
            <p style={{ margin: '20px auto 20px auto' }}>
              {this.props.t(`${this.KEY}.fields.serialNo`)}&nbsp;&nbsp;
              {newDevice && newDevice.serialNo}
            </p>
          </div>
        </td>
      </tr>
    );
  }

  renderReturnDevice = (crFormData) => {
    const { deviceInfo: { returnedDevices } } = crFormData;
    return (
      <tr>
        <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.descriptionOfChangeRequest`)}</td>
        <td>
          <div>
            <p>{this.props.t(`${this.KEY}.changeDescriptions.to`)} <strong style={style.bold}><u>{this.props.t(`${this.KEY}.changeDescriptions.returnVerb`)}</u></strong> {this.props.t(`${this.KEY}.changeDescriptions.followingExistingDevices`)}:</p>
            {
              returnedDevices.map((d, idx) => (
                <React.Fragment key={`${d.serialNo || d.deviceModel || d.deviceName || 'returned-device'}-${idx}`}>
                  <p>
                    {this.props.t(`${this.KEY}.fields.deviceAccessory`)}&nbsp;&nbsp;
                    {d.deviceName}
                  </p>
                  <p>
                    {this.props.t(`${this.KEY}.fields.model`)}&nbsp;&nbsp;
                    {d.deviceModel}
                  </p>
                  <p>
                    {this.props.t(`${this.KEY}.fields.serialNo`)}&nbsp;&nbsp;
                    {d.serialNo}
                  </p>
                  <br />
                </React.Fragment>
              ))
            }
          </div>
        </td>
      </tr>
    );
  }

  renderOthers = isReadOnly => (
    <tr>
      <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.descriptionOfChangeRequest`)}</td>
      <td>
        <div>
          <p>{this.props.t(`${this.KEY}.changeDescriptions.othersWithDetails`)}</p>
          {!isReadOnly &&
            <input ref={ref => this.others = ref} style={R.merge(style.lineInput, { width: '100%' })} type='text' />
          }
        </div>
        <br />
      </td>
    </tr>
  )

  renderTableBody = (crFormData, isReadOnly) => {
    const { action, currentUser } = crFormData;

    return (
      <React.Fragment>
        <tbody>
          {this.renderParticipantDetails(crFormData, isReadOnly)}

          <tr>
            <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.changeRequestNo`)}</td>
            <td>{!isReadOnly ? this.props.contractNo : crFormData.changeRequestNo} </td>
          </tr>

          <tr>
            <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.dateOfChangeRequest`)}</td>
            <td>{!isReadOnly ? this.formatCurrentDateDisplay() : this.formatStoredDateDisplay(crFormData && crFormData.dateOfChangeRequest)} </td>
          </tr>

          {action === 'EXTEND' && this.renderExtendDuration()}
          {action === 'ADD' && this.renderAddDevice()}
          {action === 'REPLACE' && this.renderReplaceDevice(crFormData)}
          {action === 'RETURN' && this.renderReturnDevice(crFormData)}
          {action === 'OTHERS' && this.renderOthers(isReadOnly)}

          <tr>
            <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.revisionOfSubscriptionFees`)}</td>
            {!isReadOnly && action !== 'RETURN' && action !== 'REPLACE' ?
              <td>SGD <input ref={ref => this.revisedSubscriptionFees = ref} style={R.merge(style.lineInput, { width: '15%', textAlign: 'center' })} type='number' /></td> :
              <td> {crFormData && crFormData.revisedSubscriptionFees && `SGD ${crFormData.revisedSubscriptionFees}`} </td>
            }
          </tr>

          <tr>
            <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.effectiveDateOfChangeRequest`)}</td>
            <td>
              {!isReadOnly ?
                this.formatCurrentDateDisplay() :
                this.formatStoredDateDisplay(crFormData && crFormData.effectiveDateOfChangeRequest)
              }
            </td>
          </tr>

          <tr>
            <td style={style.trLeftColumn}>{this.props.t(`${this.KEY}.fields.doctorOrOfficerName`)}</td>
            <td>{currentUser.name} </td>
          </tr>

        </tbody>
      </React.Fragment>
    );
  }

  renderSignatureText = (crFormData) => {
    const { action } = crFormData;
    return (
      <React.Fragment>
        <p><strong style={style.bold}>{this.props.t(`${this.KEY}.agreement.title`)}</strong></p>
        <p><strong style={style.bold}>{this.props.t(`${this.KEY}.agreement.acknowledge`)}</strong></p>

        <div style={{ display: 'inline-flex', paddingBottom: '10px' }}>
          <span style={{ paddingRight: '20px' }}>1. </span>
          <p style={{ margin: '0px' }}>
            {this.props.t(`${this.KEY}.agreement.item1`)}
          </p>
        </div>
        <br />

        <div style={{ display: 'inline-flex', paddingBottom: '10px' }}>
          <span style={{ paddingRight: '20px' }}>2. </span>
          <p style={{ margin: '0px' }}>
            {this.props.t(`${this.KEY}.agreement.item2`)}
          </p>
        </div>
        <br />

        {
          action === 'ADD' || action === 'REPLACE' ?
            <div style={{ display: 'inline-flex', paddingBottom: '10px' }}>
              <span style={{ paddingRight: '20px' }}>3. </span>
              <p style={{ margin: '0px' }}>
                {this.props.t(`${this.KEY}.agreement.item3`)}
              </p>
            </div> :
            <div />
        }
      </React.Fragment>
    );
  }

  renderSignature = (crFormData, isReadOnly) => (
    <React.Fragment>
      <div style={{ width: '40%', marginLeft: '40px', marginTop: '50px' }}>
        {!isReadOnly ?
          this._signatureInput('participantSignature') :
          <React.Fragment>
            <img style={{ maxWidth: '200px', maxHeight: '200px' }} src={crFormData.participantSignature} alt='' />
            <hr />
          </React.Fragment>
        }
        <span style={{ marginLeft: '10px' }}>{this.props.t(`${this.KEY}.signatures.participant`)}</span>
      </div>

      <div style={{
        width: '20%', float: 'right', marginTop: '-60px', marginRight: '40px',
      }}>
        {!isReadOnly ?
          <input type='text' style={R.merge(style.lineInput, { width: '100%' })} value={this.formatCurrentDateDisplay()} /> :
          <input type='text' readOnly style={R.merge(style.lineInput, { width: '100%' })} value={this.formatStoredDateDisplay(crFormData && crFormData.dateOfChangeRequest)} />
        }
        <span>{this.props.t(`${this.KEY}.signatures.date`)} </span>
      </div>

      <div style={{ width: '40%', marginLeft: '40px' }}>
        {!isReadOnly ?
          this._signatureInput('guardianSignature') :
          <React.Fragment>
            <img style={{ maxWidth: '200px', maxHeight: '200px' }} src={crFormData.guardianSignature} alt='' />
            <hr />
          </React.Fragment>
        }
        <span style={{ marginLeft: '10px' }}>{this.props.t(`${this.KEY}.signatures.guardian`)}</span>
      </div>

      <div style={{
        width: '20%', float: 'right', marginTop: '-60px', marginRight: '40px',
      }}>
        {!isReadOnly ?
          <input type='text' style={R.merge(style.lineInput, { width: '100%' })} value={this.formatCurrentDateDisplay()} /> :
          <input type='text' readOnly style={R.merge(style.lineInput, { width: '100%' })} value={this.formatStoredDateDisplay(crFormData && crFormData.dateOfChangeRequest)} />
        }
        <span>{this.props.t(`${this.KEY}.signatures.date`)} </span>
      </div>
      <br /><br /><br />

      <span style={{ marginLeft: '50px' }}><strong style={style.bold}>{this.props.t(`${this.KEY}.signatures.witnessedBy`)}</strong></span><br />
      <div style={{ width: '40%', marginLeft: '40px' }}>
        {!isReadOnly ?
          this._signatureInput('witnessSignature') :
          <React.Fragment>
            <img style={{ maxWidth: '200px', maxHeight: '200px' }} src={crFormData.witnessSignature} alt='' />
            <hr />
          </React.Fragment>
        }
        <span style={{ marginLeft: '10px' }}>{this.props.t(`${this.KEY}.signatures.doctorWitness`)}</span>
      </div>

      <div style={{
        width: '20%', float: 'right', marginTop: '-60px', marginRight: '40px',
      }}>
        {!isReadOnly ?
          <input type='text' style={R.merge(style.lineInput, { width: '100%' })} value={this.formatCurrentDateDisplay()} /> :
          <input type='text' readOnly style={R.merge(style.lineInput, { width: '100%' })} value={this.formatStoredDateDisplay(crFormData && crFormData.dateOfChangeRequest)} />
        }
        <span>{this.props.t(`${this.KEY}.signatures.date`)} </span>
      </div>
    </React.Fragment>
  )

  handlePerformAction = () => {
    const { crFormData, executeMethod, contractNo } = this.props;
    this.setState({ awaitPerformAction: true });

    const crFormCompleteData = R.merge(crFormData, {
      guardianName: this.guardianName.value || null,
      guardianIDType: this.guardianIDType.value || null,
      guardianIDNumber: this.guardianIDNumber.value || null,
      changeRequestNo: contractNo,
      dateOfChangeRequest: this.formatDateForStorage(),
      revisedSubscriptionFees: this.revisedSubscriptionFees ? this.revisedSubscriptionFees.value : null,
      effectiveDateOfChangeRequest: this.formatDateForStorage(),
      participantSignature: document.getElementById('participantSignature').src || null,
      guardianSignature: document.getElementById('guardianSignature').src || null,
      witnessSignature: document.getElementById('witnessSignature').src || null,
    });

    executeMethod(crFormCompleteData);
  }

  renderFooter = (action) => {
    const { closeCRForm } = this.props;
    const { awaitPerformAction } = this.state;

    return (
      <Grid container style={R.merge(style.sticky, { marginTop: '100px', marginBottom: '100px' })} justify='center'>
        <Grid item xs={5} style={{ textAlign: 'left' }}>
          <Button className='milo-btn-white' variant='contained' style={{ width: '50%' }} disabled={awaitPerformAction} onClick={closeCRForm}>
            {this.props.t(`${this.KEY}.buttons.previous`)}
          </Button>
        </Grid>
        <Grid item xs={5} style={{ textAlign: 'right' }}>
          <Button className='milo-btn-blue' variant='contained' style={{ width: '50%' }} disabled={awaitPerformAction} onClick={this.handlePerformAction}>
            {this.props.t(`${this.KEY}.buttons.proceedTo`, { action: this.getActionLabel(action) })}
          </Button>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { crFormData, isReadOnly } = this.props;
    return (
      <Paper style={{ boxShadow: 'unset' }}>
        <Grid container justify='center' style={{ padding: '10px' }}>
          <Grid style={{ minWidth: '66%' }} item xs={isReadOnly ? 12 : 8}>
            <SignaturePad {...this.state} close={this._handleClose} />
            <table className='change-request-form-table' style={{ borderCollapse: 'collapse', width: '100%' }} align='center'>
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th colSpan='2'><Typography variant='h6'>{this.props.t(`${this.KEY}.title`)}</Typography></th>
                </tr>
              </thead>
              {this.renderTableBody(crFormData, isReadOnly)}
            </table>
            <br />
            {this.renderSignatureText(crFormData)}
            {this.renderSignature(crFormData, isReadOnly)}
            {!isReadOnly && this.renderFooter(crFormData.action)}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default CRForm;
